import clsx from "clsx";

export const settingsCardLinkStyle = ({ isActive }: { isActive: boolean }) =>
  clsx(
    'rounded-md bg-white p-2 hover:text-pcx-400 group shadow hover:shadow-md inline-flex items-center gap-2 ',
    isActive ? 'text-pcx-500' : 'text-slate-700',
  )

export const settingsCardGrid = "hidden only:flex lg:flex flex-col gap-2 w-full sm:w-80"